import wrapWithProvider from "./wrapRootElement"
import wrapWithLayout from "./wrapPageElement"

export const wrapPageElement = wrapWithLayout
export const wrapRootElement = wrapWithProvider
